import { PluginFunction } from "vue";

export const useCaseExecutorPlugin: PluginFunction<void> = vue => {
  vue.prototype.$execute = vue.prototype.$container.useCaseExecutor.execute;
};
